import { IEvent } from "../../models/Event"
import React from "react";

const year = new Date().getFullYear()

export const AppFooter: React.FC<{event: IEvent}> = ({event}) => {
    return (
        <footer id="footer-container" className="site-footer">
            <div className="container site-footer__inner">
                <div className="site-footer__brand">
                    <img src={event.logo} alt="" />
                    <span>{event.shortName || event.description}</span>
                </div>
                <a className="site-footer__copyright" href="http://www.4sport.co.il">
                    © {year} כל הזכויות שמורות ל4ספורט בע״מ
                </a>
            </div>
        </footer>

    )
}
